import { X } from "@phosphor-icons/react";
import clsx from "clsx";
import Typography from "../Typography";

type DialogBoxProps = {
    title?: string;
    isOpen: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    className?: string;
};

const DialogBox = ({
    title,
    isOpen,
    onClose,
    children,
    className,
}: DialogBoxProps) => {
    if (!isOpen) return null;

    return (
        <>
            <div
                id="dialog-box-overlay"
                onClick={(event) => event.stopPropagation()}
                className={
                    "pointer-events-auto fixed inset-0 bg-surface-dark-5 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-40"
                }
            >
                <div
                    className={clsx(
                        "p-6 w-fit shadow-lg rounded-xl bg-surface-light space-y-8 z-50 max-w-full",
                        className
                    )}
                >
                    <div className="flex items-center">
                        <Typography
                            className="mr-6 text-[1rem]"
                            variant="title-medium"
                            component="h3"
                        >
                            {title}
                        </Typography>
                        <div className="flex ml-auto">
                            <X
                                size={18}
                                className="ml-auto cursor-pointer"
                                onClick={onClose}
                            />
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </>
    );
};

export default DialogBox;
